<!-- Main message bubble — hidden for SMS_COPY and BOTH_SIDE_FACE modes (both_side_face renders its own block below) -->
<div class="tw-font-body tw-text-300 tw-max-w-[300px] tw-min-w-[90px] tw-mx-4 tw-mb-0 tw-overflow-hidden tw-bg-gray-50 tw-animate-anim_scale"
     [ngClass]="bubbleClasses"
     [ngStyle]="{'animation-duration': allowAnimation ? '0ms' : '400ms'}">
  @if (showBubble) {
    <div class="tw-clear-both tw-break-words tw-whitespace-pre-line" [ngClass]="isUserImageMessage ? '' : 'tw-pt-3 tw-px-3'">
      <!-- Plain text mode: USER message or BOT message -->
      @if (!appConfig.Shared.Assistant.NonPlainTextModes.includes(chat.get('Mode'))) {
        @if (chat.get("Owner") === "USER") {
          <div>{{ displayMessage(chat.get('Message')) }}</div>
        }
        @if (chat.get("Owner") !== "USER") {
          @if (chat.get('llmResponse')) {
            <div class="llm-ack tw-mb-3">{{ chat.get('llmResponse') }}</div>
          }
          <div [innerHTML]="convertTextToHtml(displayMessage(chat.get('Message')))"></div>
          <ng-container [ngTemplateOutlet]="subMessageBlock"></ng-container>
        }
      }
      <!-- Image clubbed mode -->
      @if (isUserImageMessage) {
        <div class="tw-relative">
          <image-card (click)="imageCardClick.emit(chat)"
                      [data]="chat.get('imageArray')"
                      (openImageModal)="imageModalOpen.emit(chat)"
                      (expandImages)="imagesExpand.emit(chat)"></image-card>
        </div>
      }
      <!-- Request image modes: text + take-photo CTA -->
      @if (appConfig.Shared.Assistant.RequestImageModes.includes(chat.get('Mode'))) {
        @if (chat.get("Owner") === "USER") {
          <div>{{ displayMessage(chat.get('Message')) }}</div>
        }
        @if (chat.get("Owner") !== "USER") {
          @if (chat.get('llmResponse')) {
            <div class="llm-ack tw-mb-3">{{ chat.get('llmResponse') }}</div>
          }
          <div [innerHTML]="convertTextToHtml(displayMessage(chat.get('Message')))"></div>
          <ng-container [ngTemplateOutlet]="subMessageBlock"></ng-container>
        }
      }
      <!-- Attachment mode (image/PDF sent by user) -->
      @if (chat.get('Mode') === appConfig.Shared.Assistant.Mode.ATTACHMENT) {
        <div class="tw-relative">
          <img [src]="chat.get('tempUrl') || chat.get('Message')"
               class="tw-w-full tw-max-w-[250px] tw-rounded-xl tw-object-contain"
               alt="attachment">
        </div>
      }
      <!-- Audio mode -->
      @if (chat.get('Mode') === appConfig.Shared.Assistant.Mode.AUDIO || chat.get('Mode') === appConfig.Shared.Assistant.Mode.AUDIO_MESSAGE) {
        <audio-chat [data]="chat"
                    [user]="user"
                    [doctor]="allocatedDoctor"></audio-chat>
        <ng-container [ngTemplateOutlet]="subMessageBlock"></ng-container>
      }
      <!-- Article mode -->
      @if (chat.get('Mode') === appConfig.Shared.Assistant.Mode.ARTICLE) {
        <article [data]="chat"
                 (action)="assistantAction.emit($event)"></article>
      }
      <!-- Timestamp — SupportTicket variant (shows bot/operator label) -->
      @if (selectedChatType?.className === 'SupportTicket' && showTimestamp) {
        <div class="tw-clear-both timestamp tw-opacity-60 tw-text-right tw-py-2 ts-new tw-tracking-[0.17em] tw-uppercase tw-text-100 tw-leading-5 tw-text-gray-400">
          {{ formatTime(chat.get('createdAt')) }}&nbsp;{{ timestampLabel }}
        </div>
      }
      <!-- Timestamp — non-SupportTicket variant -->
      @if (selectedChatType?.className !== 'SupportTicket' && showTimestamp) {
        <div class="tw-clear-both timestamp tw-opacity-60 tw-text-right tw-mb-2.5 ts-new tw-tracking-[0.17em] tw-uppercase tw-text-100 tw-leading-5 tw-text-gray-400">
          {{ formatTime(chat.get('createdAt')) }} &nbsp; {{isInternalUser ? chat.get('OperatorName') || chat.get('Owner') : ''}}
        </div>
      }
    </div>
  }

  @if (hasMultiSelectCta) {
    <div class="tw-w-full tw-flex tw-bg-white tw-flex-col tw-justify-start tw-rounded-b-2 tw-animate-anim_scale"
         [style.animation-duration]="allowAnimation ? '0ms' : '400ms'">
      <multi-select-selector
        [isClosedTicket]="isClosedTicket"
        [data]="chat"
        (optionSelected)="assistantAction.emit($event)">
      </multi-select-selector>
    </div>
  }

  <!--  action cta (take photo etc.) -->
  @if (hasActionCta) {
    <div class="tw-w-full tw-flex">
      @for (inputs of (chat.get('Inputs') || []); track $index) {
        <span class="tw-bg-teal-600 tw-text-white tw-px-4 tw-py-1 tw-w-full tw-rounded-b-1.5 tw-flex tw-items-center tw-justify-center tw-font-semibold tw-font-lexend"
              (click)="assistantAction.emit({chat: chat, index: $index, input: inputs})">
          {{inputs.text}}
          <cs-icon class="tw-h-6 tw-w-6 tw-ml-1" [iconName]='"chevron_right"'></cs-icon>
        </span>
      }
    </div>
  }
  <!-- rebranded single selector (TREE CTAs) — attached to bubble bottom, mutually exclusive with action CTA -->
  @if (hasTreeCta && !hasImageInput(chat)) {
    <div class="tw-w-full tw-flex tw-bg-white tw-flex-col tw-justify-start tw-rounded-b-2 tw-animate-anim_scale" [ngStyle]="{'animation-duration': allowAnimation ? '0ms' : '400ms'}">
      <rebranded-single-selector
        [isClosedTicket]="isClosedTicket"
        [data]="chat"
        (optionSelected)="assistantAction.emit($event)">
      </rebranded-single-selector>
    </div>
  }
</div>

@if (hasTreeCta && hasImageInput(chat)) {
  <div class="tw-max-w-[350px] -tw-mt-5 tw-mx-2 tw-min-w-[90px] tw-flex tw-flex-wrap tw-animate-anim_scale tw-mb-8" [ngStyle]="{'animation-duration': allowAnimation ? '0ms' : '400ms'}">
    <rebranded-single-selector
      class="tw-w-full"
      [isClosedTicket]="isClosedTicket"
      [data]="chat"
      (optionSelected)="assistantAction.emit($event)">
    </rebranded-single-selector>
  </div>
}

<!-- Both-side-face images block — rendered as a separate card outside the bubble -->
@if (chat.get('Mode') === appConfig.Shared.Assistant.Mode.REQUEST_IMAGE_RESPONSE_BOTH_SIDE_FACE) {
  <div class="tw-relative tw-float-right tw-flex tw-justify-end tw-items-center tw-pt- tw-px-4 tw-gap-1">
    @if (!chat.get('leftSignedUrlDeleted')) {
      <div class="tw-w-[140px]">
        <img (click)="bothSideFaceImageClick.emit(getImageTypeMappingFace('LEFT_SIDE_FACE'))"
             [src]="chat.get('bothSideTempUrls')[0]"
             class="tw-w-full tw-h-[200px] tw-shadow-z1 tw-object-cover tw-rounded-t-4 tw-rounded-br-4"
             alt="">
      </div>
    }
    @if (!chat.get('rightSignedUrlDeleted')) {
      <div class="tw-w-[140px]">
        <img (click)="bothSideFaceImageClick.emit(getImageTypeMappingFace('RIGHT_SIDE_FACE'))"
             [src]="chat.get('bothSideTempUrls')[1]"
             class="tw-w-full tw-h-[200px] tw-shadow-z1 tw-object-cover tw-rounded-t-4 tw-rounded-br-4"
             alt="">
      </div>
    }
    @if (chat.get('leftSignedUrlDeleted') && chat.get('rightSignedUrlDeleted')) {
      <div class="tw-bg-green-100 tw-px-4 tw-pt-4 tw-pb-3 tw-shadow-[0px_2px_3px_0px_rgba(0,0,0,0.1)] tw-rounded-tl-5 tw-rounded-tr-5 tw-rounded-br-5 tw-rounded-bl-[0px]">
        <p i18n="@@imagesDeleted"
           class="tw-text-black">These images have been deleted.</p>
      </div>
    }
  </div>
}

<!-- Optional subMessage rendered below the main message content -->
<ng-template #subMessageBlock>
  @if (hasSubMessage()) {
    <br />
    <div [innerHTML]="convertTextToHtml(displayMessage(chat.get('subMessage')))"></div>
  }
</ng-template>
